import { Component, ElementRef, EventEmitter, Inject, InjectionToken, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { CookieService } from 'ngx-cookie';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { find } from 'lodash';

import { AclDialogComponent, ConfirmDismissDialogComponent, PaymentReceiptComponent } from 'app/modules/shared/components';
import { AddSuccessfullyDialogComponent } from 'app/modules/app-components/add-successfully-dialog/add-successfully-dialog.component';
import { AddDialogComponent } from 'app/modules/app-components/add-dialog/add-dialog.component';
import { CancelApptDialogComponent } from 'app/modules/app-components/cancel-appt-dialog/cancel-appt-dialog.component';
import { CannedServiceDialogComponent } from 'app/modules/app-components/canned-service-dialog/canned-service-dialog.component';
import { PaymentAddComponent } from 'app/modules/app-components/payment-add/payment-add.component';
import { ReviewDialogComponent } from 'app/modules/app-components/review-dialog/review-dialog.component';
import { ItemDialogComponent } from 'app/modules/app-components/item-dialog/item-dialog.component';
import { LocationAddComponent } from 'app/modules/app-components/location-add/location-add.component';
import { ServiceAuthorisationDialogComponent } from 'app/modules/app-components/service-authorisation-dialog/service-authorisation-dialog.component';
import { CustomerHistoryImportedDialogComponent } from 'app/modules/app-components/customer-history-imported-dialog/customer-history-imported-dialog.component';
import { FeeAddComponent } from 'app/modules/app-components/fee-add/fee-add.component';
import { ChatService } from 'app/modules/chat/chat.service';
import { CreateStatementDialogComponent } from 'app/modules/app-components/create-statement-dialog/create-statement-dialog.component';
import { SupplierAddComponent } from 'app/modules/app-components/supplier-add/supplier-add.component';

import { ACLService, DataService, DateService, HelperService, HTTPService, SharedService, SocketService } from 'app/services';
import { QboToastService } from 'app/services/qbo.toast.service';
import { config, messages, primaryContactConstant, unAssignedPartsTechPartsMessage } from 'app/constants';
import { events } from 'app/constants/socket-events';
import { addMenuList, mitchell1RepairGuidesMenu, serviceLookUpMenu, quickTireLookupMenu } from 'app/navs/_tenant';

import { TrialCampaignDialogComponent } from 'app/modules/app-components/trial-campaign-dialog/trial-campaign-dialog.component';
import { ServiceLookupComponent } from 'app/modules/app-components/service-lookup/service-lookup.component';

import { environment } from 'environments/environment';
import { SwitchLocationDialogComponent } from '../switch-location-dialog/switch-location-dialog.component';
import { audibleNotificationSettings } from 'app/services/sharedInterfaces';
import { PurchasePaymentOrder } from 'app/modules/inventory/components/purchase-order/components/purchase-payment-order/purchase-payment-order.component';
import { CreditPaymentAddComponent } from '../credit-or-edit-memo-payment/credit-or-edit-memo-payment.component';
import { ApplyCreditPaymentComponent } from '../apply-credit-payment/apply-credit-payment.component';
import { SwitchCorporateDialogComponent } from '../switch-corporate-dialog/switch-corporate-dialog.component';
import { VehicleSpecificLookupDialogComponent } from '../../estimate/components/vehicle-specific-lookup-dialog/vehicle-specific-lookup-dialog.component';
import { ScriptLoaderService } from 'app/services/script-loader.service';
import { SalesCodeAssignDialogComponent } from 'app/modules/app-components/sales-code-assign-dialog/sales-code-assign-dialog.component';
import { datetimeFormat } from 'app/constants/date-time-format';
import { WarrantyAssignDialogComponent } from '../warranty-assign-dialog/warranty-assign-dialog.component';
export const WINDOWOBJ = new InjectionToken<Window>('Global window object', {
  factory: () => window,
});

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() navs: any[] = [];
  @Output() disableApt = new EventEmitter<any>();

  @ViewChild('profileDropdownContainer', { static: true }) profileDropdownContainer: ElementRef;
  @ViewChild('intercomBtn', { static: true }) isMultiLocationEnabled: boolean = false;

  intercomBtn: ElementRef;
  isIntercomSetupDone: boolean = false;
  openChatCount: number = 0;
  brandLogoLink: string = '';
  user: any = {};
  openQboToast: boolean = false;
  activeLinkId: string = '';
  // estimate = this.helperService.deepCopy(defaultEstimate);
  customerNotifications = [];
  privileges = [];
  addMenuItems: any[] = addMenuList;
  notificaitonsSkip: number = 0;
  notificationsTotalRecord: number = 0;
  notificationsLimit: number = config.notificaitonsPageSize;
  showToaster: boolean = false;
  isProfileCardVisible: boolean = false;
  isSearchVisible: boolean = false;
  isAddDialogModalOpen: boolean = false;
  role: string = '';
  selected: boolean = false;
  isMitchell1Loading: boolean = false;
  isMitchell1Connected: boolean = false;
  isMitchell1CredsLoaded: boolean = false;
  marketingAccessType: string = '';
  selectedLocked: boolean = false;
  timeOut: any = '';
  basicRoles: string[] = ['super', 'onboarder', 'engg', 'sales'];
  tokenData: any = {};
  toaster: any = {
    text: '',
    icon: 'fal fa-file-alt',
    buttons: {
      undo: 'Undo',
      sendInvoice: 'Send Invoice',
    },
  };
  allowedMenuItems = {
    dashboard: true,
    workboard: true,
    calendar: true,
    customers: true,
    catalog: true,
    inventory: true,
    marketing: true,
    reviews: true,
    reports: true,
    addButton: true,
    settings: true,
    notifications: true,
    intercom: true,
    profile: true,
    companies: true,
    templates: true,
    users: true,
    features: true,
    chats: true,
    userCenter: true,
  };
  serviceLookUpMenu = serviceLookUpMenu;
  mitchell1RepairGuidesMenu = mitchell1RepairGuidesMenu;
  quickTireLookupMenu = quickTireLookupMenu;
  counts: any = {};

  private broadcastChannel: any;
  private unsubscribe: Subject<boolean> = new Subject<boolean>();
  isChatEnabled: boolean = false;
  isMitchellIntegrationEnabled: boolean = false;
  isMotorLookupEnabled: boolean = false;
  isMitchell1EstimatorEnabled: boolean = false;
  isAdminTechControlEnabled: boolean = false;
  isQuickTireLookupEnabled = false;
  notificationSettings: audibleNotificationSettings;
  employeeId: string;
  corporateId: string;
  isNavigationDisabled = false;
  openNav = false;
  fetchingData = false;
  canSwitchLocation: boolean = false;
  shopAccessesList: any[] = [];
  userInfo;
  isInvoiceLockEnabled: boolean = false;
  isInvoiceLockOn: boolean = false;
  showGlobalSearch: boolean = false;
  isTireConnectConnected: boolean = false;
  isTireHubConnected: boolean = false;
  itemSettings: any = {};
  notifyTrue = false;
  alDashboardUrl: string = 'https://aldashboard.myautoleap.com/#!/login';
  isMarkPsDashboard: boolean = false;
  isNotificationPanelVisible: boolean = false;
  isTireStorage2Enabled: boolean = false;
  showCustomToaster: string = 'hide';
  customerToasterOptions: any = {
    heading: 'RO Created Succesfully',
    text: 'Visit the new repair order to add more jobs!',
    icon: 'far fa-check-circle',
    actionKey: 'navigate',
    isEnhancedVersion: true,
  };
  tierTypeLabels = {
    essentials: 'Essentials',
    pro: 'Pro',
    elite: 'Elite',
    'ent-gen': 'Ent. General',
    'ent-fastlap': 'Ent. FastLap',
    'ent-midas': 'Ent. Midas',

    starter: 'Essentials (OLD)',
    smb: 'SMB (OLD)',
  };

  constructor(
    private dialogService: DialogService,
    private dataService: DataService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private router: Router,
    private socketService: SocketService,
    private sharedService: SharedService,
    private cookieService: CookieService,
    private aclService: ACLService,
    private chatService: ChatService,
    private qboToastService: QboToastService,
    private dateService: DateService,
    @Inject(WINDOWOBJ) private _window: Window,
    private scriptLoaderService: ScriptLoaderService,
  ) {}

  onTosterAction(event: any) {
    if (event?.action === 'navigate') {
      this.helperService.openPageInNewExistingTab(event?.data?.url, event?.data?.estimateId);
    }
  }

  ngOnInit() {
    const { isMultiLocationEnabled, corporateId } = this.helperService.getCompany();
    this.corporateId = corporateId;
    this.setWorldpacIntegration();
    //this.getTireConnectIntegrationSettings();
    //this.getTireHubIntegrationSettings();
    /**
     * This subscribe is called from the following
     * - customer-list.component
     * - vehicle-side-list.component
     * - calendar-view.component
     */
    if (!this.helperService.isAppleDevice()) {
      this.broadcastChannel = new BroadcastChannel('intercom-close');
    }

    this.setDataListeners();

    if (!this.basicRoles.includes(this.helperService.getCompany().role)) {
      this.fetchNotifications();
      this.getOpenChatCount();
    }

    this.setUserDetails();
    this.setClickOutSideListeners();
    this.brandLogoLink = `${this.aclService.getEntry(this.role)}`;

    if (!isMultiLocationEnabled) {
      this.setSockets();
    }
    window.addEventListener('storage', this.syncBadgeCountAcrossTabs.bind(this));

    const initialBadgeCount = localStorage.getItem('notificationsBadgeCount');
    if (initialBadgeCount) {
      this.notificationsTotalRecord = JSON.parse(initialBadgeCount);
    }
  }

  setNotificationPanelState(isNotificationPanelVisible: boolean) {
    this.isNotificationPanelVisible = isNotificationPanelVisible;
  }
  dismissEventCall($event:any){
    localStorage.setItem('notificationsBadgeCount', null);
    this.fetchNotifications();

  }

  iconClick() {
    this.showGlobalSearch = true;
  }
  ngOnDestroy() {
    if (this.broadcastChannel) {
      this.broadcastChannel.close();
    }

    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();

    window.removeEventListener('storage', this.syncBadgeCountAcrossTabs.bind(this));
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }

    (<any>window).Intercom('shutdown');
  }

  private syncBadgeCountAcrossTabs(event: StorageEvent) {
    if (event.key === 'notificationsBadgeCount') {
      const updatedBadgeCount = JSON.parse(event.newValue || '0');
      this.notificationsTotalRecord = updatedBadgeCount;
    }
  }

  makeTokenData() {
    if (this.isIntercomSetupDone) return;
    this.isIntercomSetupDone = true;

    const token = this.cookieService.getObject('alpat');

    if (token) {
      const data = this.helperService.jwtDecode(token);
      const companyData: any = {};

      if (this.dataService.company.externalId) {
        if (this.dataService.company) {
          companyData.id = this.dataService.company.externalId;
          companyData.name = this.dataService.company.name;
          companyData.website = this.dataService.company.website;
          companyData.created_at = this.dataService.company.createdAt;
          companyData['Primary Contact'] = this.dataService.company.phone;
          companyData['Company Type'] = this.dataService.company.companyType;
          companyData['Account Stage'] = this.dataService.company.status;

          if (this.dataService.company.sfUid) {
            companyData.id = this.dataService.company.sfUid;
          }
        }
      }

      if (data) {
        (<any>window).Intercom('boot', {
          app_id: environment.APP_ID,
          name: data.fullName,
          email: data.userName,
          phone: data.otherUserName,
          permission: data.role,
          customer: data.name,
          company_email: data.email,
          url: this.router.url,
          alignment: 'right',
          custom_launcher_selector: '#intercom-chat',
          horizontal_padding: 100,
          vertical_padding: 0,
          hide_default_launcher: true,
          company: companyData,
        });
        (<any>window).Intercom('onHide', () => {
          this.hideIntercom();
          (<any>window).Intercom('hide');
          this.selected = false;
          this.selectedLocked = false;

          if (this.broadcastChannel) {
            this.broadcastChannel.postMessage('close');
          }
        });

        return data;
      }
    }

    return {};
  }

  hideIntercom() {
    this.selected = false;
    if (this.intercomBtn.nativeElement && this.intercomBtn.nativeElement.classList) {
      this.intercomBtn.nativeElement && this.intercomBtn.nativeElement.classList.remove('highlight');
    }
  }

  setRouteListener() {
    this.router.events
      .pipe(takeUntil(this.unsubscribe))
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((activeRoute: any) => {
        const url: string = activeRoute.url;
        this.setActiveRoute(url);
        (<any>window).Intercom('update', {
          app_id: environment.APP_ID,
          email: this.tokenData.userName,
          url: this.router.url,
          alignment: 'right',
        });
      });
  }

  showCustomEnhancedToaster(url: string, estimateId: string) {
    this.showCustomToaster = 'show';
    this.customerToasterOptions = {
      heading: 'RO Created Succesfully',
      text: 'Visit the new repair order to add more jobs!',
      icon: 'far fa-check-circle',
      actionKey: 'navigate',
      data: { url, estimateId },
      isEnhancedVersion: true,
    };
  }

  setDataListeners() {
    if (this.broadcastChannel) {
      this.broadcastChannel.onmessage = () => {
        if (this.selected) (<any>window).Intercom('hide');
        if (this.selectedLocked) (<any>window).Intercom('hide');
      };
    }

    this.dataService
      .getData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ data }) => {
        if (data && data.key === 'request-reconnect-speedDial') {
          this.setWorldpacIntegration(true);
        }

        if (data && data.key === 'open-history-dialog') {
          const { payload, type, isOpenFromRO } = data.data;

          this.openHistoryImportDialog(payload, type, isOpenFromRO);
        }

        if (data && data.key === 'open-qtq-ts-dialog') {
          const { payload } = data.data;
          this.getIntegrationSettings({ ...payload, isRunTireStorageFlow: true && this.isTireStorage2Enabled });
        }

        if (data && data.key === 'show-enhanced-custom-toaster') {
          const { payload } = data.data;
          if (payload.estimateURL && payload?.tsCreatedRoId) {
            this.showCustomEnhancedToaster(payload.estimateURL, payload?.tsCreatedRoId);
          }
        }

        if (data && data.key === 'open-item-dialog') {
          const { payload, type, isOpenFromRO, vehicleYear, isDisabled, estimate, onlineItem } = data.data;

          this.openItemDialog(payload, type, isOpenFromRO, vehicleYear, isDisabled, estimate, onlineItem);
        }

        if (data && data.key === 'open-supplier-dialog') {
          const { supplierId, type, isOpenFromRO, vehicleYear } = data.data;

          this.openSupplierDialog(supplierId, type);
        }

        if (data && data.key === 'open-sublet-supplier-dialog') {
          const { supplierId, isSubletSupplierType, isOpenFromRO, vehicleYear } = data.data;

          this.openSubletSupplierDialog(supplierId, isSubletSupplierType, isOpenFromRO);
        }

        if (data && data.key === 'open-fee-dialog') {
          const { payload, isOpenFromRO } = data.data;

          this.openFeeDialog(payload, isOpenFromRO);
        }

        if (data && data.key === 'open-location-dialog') {
          const { payload, type, isOpenFromRO } = data.data;

          this.openLocationDialog(payload, type, isOpenFromRO);
        }

        if (data && data.key === 'unassign-partstech-parts') {
          this.openPartsTechParts({
            ...data.data,
          });
        }
        if (data.key === 'redirect-manufacture-list') {
          this.helperService.openPageInNewExistingTab('/settings/integrations/manufacturers', '_blank');
        }
        if (data && data.key === 'pending-auth-services') {
          if (data.data) {
            this.openServiceAuthorizationDialog({
              ...data.data,
            });
          }
        }

        if (data.type === 'dialog') {
          switch (data.tab) {
            case 'add-customer':
              this.openAddDialog(data.tab, data.from, data.data);
              break;

            case 'add-vehicle':
              this.openAddDialog(data.tab, data.from, {
                ...(data.data || {}),
                _id: data._id,
                fullName: data.fullName,
              });
              break;
            case 'open-sales-code-assign-modal':
              this.openAssignSalesCodeDialog(data.data);
              break;

            case 'open-warranty-assign-modal':
              this.openAssignWarrantyDialog(data.data);
              break;

            case 'add-appointment':
              this.openAddDialog(data.tab, data.from, data.data);
              break;

            case 'add-canned':
              this.openCannedServiceDialog(data.data);
              break;
            // case 'add-flat-rate':
            //   this.openflatRateItemDialog(data.data);
            //   break;

            case 'add-payment':
              this.openPaymentDialog(data.data);
              break;

            case 'add-credit-payment':
              this.openCreditPaymentDialog(data.data);
              break;

            case 'add-apply-credit-payment':
              this.openApplyCreditPaymentDialog(data.data);
              break;

            case 'add-purchase':
              this.openPurchaseDialog(data.data);
              break;

            case 'add-statement':
              this.openStatementDialog(data.data);
              break;

            case 'add-review':
              this.openReviewDialog({
                ...data.data,
                isReviewRequestOnly: data.from === 'review-summary',
              });
              break;

            case 'trial-campaign-dialog':
              if (this.marketingAccessType === 'trial') {
                this.openTrialPromotionalDialog({
                  ...data.data,
                });
              }
              break;

            case 'cropper-modal':
              this.timeOut = setTimeout(() => {
                this.isProfileCardVisible = data.data.open;
              }, 50);
              break;

            default:
              break;
          }
        }

        if (data.type === 'passdata') {
          if (data.key === 'load-notifications' && data.data) {
            this.fetchNotifications();
          }
        }

        if (data && data.key === 're-evaluate-privilleges' && data.data && data.data.employeeId) {
          this.getEmployeeDetails(data.data.employeeId);
        }
      });
  }

  onCloseCustomToaster() {
    this.showCustomToaster = 'hide';
  }

  openAssignSalesCodeDialog(data?: any) {
    const { item = {}, isShowMultipleView = false, orderId, openFrom = '', unassignedServices = [], type, customerId = '', vehicleId = '' } = data || {};

    const ref = this.dialogService.open(SalesCodeAssignDialogComponent, {
      closeOnEscape: false,
      width: '1356px !important',
      styleClass: 'add-dialog sales-code-assign-modal',
      showHeader: false,
      data: {
        ...data,
        isShowMultipleAssignView: isShowMultipleView,
        itemName: item?.title || '',
        orderId,
        openFrom,
        unassignedServices,
        type,
        customerId,
        vehicleId,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (data?.openFrom && data?.assignedItems?.length) {
          this.dataService.sendData(this.dataService.typePassData(data?.openFrom, { assignedSalesCodeItems: data.assignedItems }));
        }
      }

      onClose.unsubscribe();
    });
  }

  openAssignWarrantyDialog(data?: any) {
    const { item = {}, isShowMultipleView = false, orderId, openFrom = '', unassignedServices = [], type, customerId = '', vehicleId = '' } = data || {};

    const ref = this.dialogService.open(WarrantyAssignDialogComponent, {
      closeOnEscape: false,
      width: '1356px !important',
      styleClass: 'add-dialog sales-code-assign-modal',
      showHeader: false,
      data: {
        ...data,
        isShowMultipleAssignView: isShowMultipleView,
        itemName: item?.title || '',
        orderId,
        openFrom,
        unassignedServices,
        type,
        customerId,
        vehicleId,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (data?.openFrom && data?.assignedItems?.length) {
          this.dataService.sendData(this.dataService.typePassData(data?.openFrom, { assignedSalesCodeItems: data.assignedItems }));
        }
      }

      onClose.unsubscribe();
    });
  }

  setSockets(shopId: string = '') {
    let _shopId = shopId;
    let user = this.helperService.getCompany();

    if (!_shopId) {
      _shopId = user.shopId;
    }

    this.socketService
      .socketOn(`${events.notifications.notifications}${_shopId}`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        if (data.type === 'tech_raised_flag') {
          this.helperService.showToaster('error', data.techFlagMessage);
          this.fetchNotifications(true);
          //this.dataService.sendData(this.dataService.typePassData('fetch-notifications', this.dataService.currentShopId));
          this.getOpenChatCount();
        } else if (data.type === 'statement_download') {
          window.open(data.url);
        } else {
          this.employeeId = this.sharedService.getCompany().employeeId;
          this.getOpenChatCount();
          this.fetchNotifications(true);
          // this.dataService.sendData(this.dataService.typePassData('fetch-notifications', this.dataService.currentShopId));
        }
      });

    this.socketService
      .socketOn(`${user.companyId}_CHAT_OPEN_COUNT_UPDATED`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        this.getOpenChatCount();
      });
    this.socketService
      .socketOn(`${user.companyId}_CONVERSATIONS_UPDATE`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((conversation) => {
        if (!conversation) return;
        this.getOpenChatCount(true, conversation.isContactClosed);
      });
    this.socketService
      .socketOn(`${user.iat}_${user.shopId}_BULK_STATEMENT_SENT`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        this.qboToastService.updateToaster(data);
        if (data.isComplete) {
          this.dataService.sendData(this.dataService.typePassData('bulk-statement-response', data));
          this.dataService.showQboModel = false;
          this.qboToastService.updateToaster(data);
        }
      });
    this.socketService
      .socketOn(`${user.iat}${user.shopId}`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data && data.type === 'location-switch') {
          this.setUserDetails();
        } else if (data.downloadStatement) {
          try {
            const isDownloaded = localStorage.getItem(`statement-${data.statementId}`) === 'true';

            if (!isDownloaded) {
              localStorage.setItem(`statement-${data.statementId}`, 'true');
              window.open(data.url);
            }
          } catch (err) {
            // console.log(err);
          }
        } else if (data.multiQboResponse) {
          this.dataService.sendData(this.dataService.typePassData('multi-qbo-response', data));
          this.qboToastService.updateToaster(data);
          if (data.isComplete) {
            this.dataService.showQboModel = false;
          }
        } else {
          this.logoutWithError(data);
        }
      });

    this.socketService
      .socketOn(`logout_${user.userId}${user.shopId}`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        this.logoutWithError(data);
      });
    this.socketService
      .socketOn(`profile_update_${user.userId}${user.shopId}`)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        this.setUserDetails();
      });
  }

  setGainSightSettings(company) {
    try {
      const { companyId, companyName, companyType } = this.helperService.getCompany();
      const currentShop = Array.isArray(this.user?.currentShopId) ? this.user?.currentShopId[0] : this.user?.currentShopId;
      const userFields = {
        id: `${this.user?.externalId || ''}${currentShop?.sfUid || ''}`,
        accountId: currentShop?.sfUid || '',
        email: this.user?.email || '',
        firstName: this.user?.firstName || '',
        lastName: this.user?.lastName || '',
        role: this.user?.role || '',
        signUpDate: new Date(this.user.createdAt),
      };
      const accountFields = {
        id: currentShop?.sfUid || '',
        name: companyName || '',
        tenantType: companyType || '',
        sfdcId: currentShop?.sfUid || '',
        plan: currentShop?.plan || '',
        implStage: currentShop?.implementationStatus || '',
        activationDate: new Date(currentShop?.activationDate),
        multiLocation: this.dataService.isMultiLocationEnabled ? 'Yes' : 'No',
        enterprise: company.enterprise,
        tierType: this.tierTypeLabels[company.tierType],
        tenantStatus: company.status == 'Unlive' ? 'Delete' : company.status,
        subsRevoked: !company.subscription,
      };

      if (this.dataService.isMultiLocationEnabled) {
        accountFields.name = `${companyName} - ${this.dataService.currentShop.shopFullName}` || '';
        accountFields.id = currentShop?.sfUid || '';
      }
      (<any>window).aptrinsic('identify', userFields, accountFields);
    } catch (err) {}
  }

  setPendoSettings() {
    try {
      const { companyId, companyName } = this.helperService.getCompany();
      const userFields = {
        id: this.user._id,
        email: this.user.email,
        full_name: `${this.user.firstName} ${this.user.lastName}`,
        role: this.user.role,
        creationDate: new Date(this.user.createdAt).getTime(),
      };
      const accountFields = {
        id: companyId,
        name: companyName,
      };
      (<any>window).pendo.initialize({
        visitor: userFields,
        account: accountFields,
      });
    } catch (err) {
      // console.log('Error Pendo', err);
    }
  }

  logoutWithError(data: any) {
    // Setting error message into state
    const navigationExtras: NavigationExtras = {
      state: data,
    };
    this.helperService.logout(data);
  }

  setActiveRoute(url: string) {
    if (url) {
      this.activeLinkId = url.split('/')[1];
    }
  }

  getTireHubIntegrationSettings() {
    return this.httpService.isTireHubConnected({ populateItemAndPricing: false, populateTireHubRefs: true });
    // .then(
    //   (data) => {
    //     if (data) {
    //       const { settings, isTireHubConnected, pricings = [] } = data;

    //       if (isTireHubConnected) {
    //         this.isTireHubConnected = true;
    //       }

    //       if (settings) {
    //         this.itemSettings.tireHub = {
    //           tire: {
    //             pricing: settings?.tirePricingId || {},
    //             partsTechCostCalMethod: settings?.tireCostCalMethod || '',
    //           },
    //         };
    //       }
    //     }
    //   },
    //   (err) => {
    //     this.helperService.showToaster('error', err);
    //   }
    // );
  }

  getTireConnectIntegrationSettings() {
    return this.httpService.isTireConnectConnected({ populateItemAndPricing: true, populateTireConnectRefs: true });
    // .then(
    //   (data) => {
    //     if (data) {
    //       const { settings, isTireConnectConnected } = data;

    //       // Setting connection status and username and keys
    //       if (isTireConnectConnected) {
    //         this.isTireConnectConnected = true;
    //       }

    //       if (settings) {
    //         this.itemSettings.tireConnect = {
    //           tire: {
    //             pricing: settings?.tirePricingId || {},
    //             partsTechCostCalMethod: settings?.tireCostCalMethod || '',
    //           },
    //         };
    //       }
    //     }
    //   },
    //   (err) => {
    //     this.helperService.showToaster('error', err);
    //   }
    // );
  }

  setUserDetails() {
    const { role, userId, qboId } = this.helperService.getCompany();

    this.role = role;
    this.dataService.isQuickbooksConnected = !!qboId;

    if (this.basicRoles.includes(role)) {
      this.httpService.getUser(userId).then(
        (user) => {
          user.email = user.userName;
          user.name = `${user.firstName} ${user.lastName}`;
          user.initials = this.helperService.fetchInitials(user.name);
          this.user = { ...user };
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
      /** Get User data */
    } else {
      this.httpService
        .initUserAppData()
        .then(
          ([company, user, settings]: any) => {
            this.user = user;
            this.setPrivileges();

            if (company && user) {
              const { appsettings, address, notification, businessSummaryReportInfo, enterprise } = company;
              this.dataService.setEnterprise(enterprise);

              if (user.partnerId) this.dataService.partnerId = user.partnerId;
              if (user.email) this.dataService.userEmail = user.email;

              if (user.partnerId) this.dataService.partnerId = user.partnerId;
              if (user.email) this.dataService.userEmail = user.email;
              user.currentShopId = user.currentShopId && user.currentShopId.length ? user.currentShopId[0] : user.currentShopId;
              if (user.currentShopId?._id) {
                user.shopName = user.currentShopId.name;
                user.shortName = user.currentShopId.shortName?.length > 6 ? user.currentShopId.shortName.substring(0, 6) : user.currentShopId.shortName;
                user.shopColor = user.currentShopId.locationColor;

                this.dataService.warehouse = user.currentShopId.warehouse;
                this.dataService.currentShopId = user.currentShopId._id;
                this.dataService.currentShopTz = user.currentShopId.timezone;
                this.dataService.currentShop = { shopFullName: user.shopName, shopName: user.shortName, shopColor: user.shopColor };

                if (appsettings?.isMultiLocationEnabled) {
                  this.setSockets(user.currentShopId._id);
                }
                localStorage.setItem('currentShop', this.dataService.currentShopId);
                localStorage.setItem('currentShopTz', this.dataService.currentShopTz);
                localStorage.setItem('currentShopInfo', JSON.stringify({ shopFullName: user?.shopName, shopName: user?.shortName, shopColor: user?.shopColor, shopId: user?.currentShopId?._id }));
              }

              if (appsettings?.isMultiLocationEnabled && user?.currentShopId?.notification?.enabled) {
                this.notificationSettings = {
                  enabled: user.currentShopId.notification.enabled,
                  officeApp: user.currentShopId.notification.officeApp,
                  techApp: user.currentShopId.notification.techApp,
                };
              } else if (notification?.enabled) {
                this.notificationSettings = {
                  enabled: notification.enabled,
                  officeApp: notification.officeApp,
                  techApp: notification.techApp,
                };
              } else if (user?.currentShopId?.notification?.enabled) {
                this.notificationSettings = {
                  enabled: user.currentShopId.notification.enabled,
                  officeApp: user.currentShopId.notification.officeApp,
                  techApp: user.currentShopId.notification.techApp,
                };
              }

              if (company.businessSummaryReportInfo) {
                this.dataService.businessSummaryReportInfo = businessSummaryReportInfo;
              }

              if (user.shopAccesses?.length) {
                this.shopAccessesList = user.shopAccesses;
                this.dataService.shopAccessesList = this.shopAccessesList;
                this.canSwitchLocation = user.shopAccesses.length > 1;
                this.dataService.canSwitchLocation = this.canSwitchLocation;

                user.shopAccesses.map((shop) => {
                  if (shop && shop._id) {
                    this.dataService.shopsMap[shop._id] = {
                      shopName: shop.shortName,
                      shopColor: shop.locationColor,
                      shopTitle: shop.name,
                    };
                  }
                });
              }

              user.name = `${user.firstName} ${user.lastName}`;
              user.initials = this.helperService.fetchInitials(user.name);
              this.user = { ...user };

              this.dataService.company = company;

              if (company?.address?.country) {
                this.dataService.locationAddress = company.address;
                this.dataService.isCountryCanada = company?.address?.country !== 'USA';
              }

              this.helperService.setCompanyRefInCookies(company._id);
              this.tokenData = this.makeTokenData();
              this.setRouteListener();
              this.dataService.isSupportAdminAccount = user.isSupportUser;

              if (appsettings) {
                this.dataService.isItemSoldReportEnhancement = appsettings.isItemSoldReportEnhancement;
                this.dataService.isInventoryEnabled = appsettings.inventoryEnabled;
                this.dataService.isMarketingEnabled = appsettings.isMarketingEnabled;
                this.dataService.isMarketingLeadAttributionEnabled = appsettings.isMarketingLeadAttributionEnabled;
                this.dataService.isCRMDashboardEnabled = appsettings.isCRMDashboardEnabled && appsettings.isMarketingEnabled;
                this.dataService.isChatEnabled = appsettings.isChatEnabled;
                this.isChatEnabled = appsettings.isChatEnabled;
                this.isMitchellIntegrationEnabled = appsettings.isMitchellIntegrationEnabled;
                this.isMitchell1EstimatorEnabled = appsettings.isMitchell1EstimatorEnabled;
                this.isAdminTechControlEnabled = appsettings.isAdminTechControlEnabled;
                this.isMarkPsDashboard = appsettings.isMarkPsDashboard;
                this.isMultiLocationEnabled = appsettings.isMultiLocationEnabled;
                this.dataService.isManualInvCodeEnabled = appsettings.isManualInvCodeEnabled;
                this.dataService.isROPrioritiesEnabled = appsettings.isROPrioritiesEnabled;
                this.dataService.isRepairDiagramEnabled = appsettings.isAdminRepairDiagramEnabled;
                this.dataService.isDeferredServiceEnabled = appsettings.isDeferredServiceEnabled;
                this.dataService.isDeferredServiceEnabled = appsettings.isDeferredServiceEnabled;
                this.dataService.isAddressOnApptVisible = appsettings.isAddressOnApptVisible;
                this.dataService.isOrderHistoryEnabled = appsettings.isOrderHistoryEnabled;
                this.dataService.isReturnFeatureEnabled = appsettings.isReturnFeatureEnabled;
                this.dataService.attendanceLogEnabled = appsettings.attendanceLogEnabled;
                this.dataService.isSendInspectionEnabled = appsettings.isSendInspectionEnabled;
                this.dataService.isSupplierProfileEnabled = appsettings.isSupplierProfileEnabled;
                this.dataService.vinScannerEnabled = appsettings.vinScannerEnabled;
                this.dataService.nexpartEnabled = appsettings.nexpartEnabled;
                this.dataService.enableTaxRatesBreakdown = appsettings.enableTaxRatesBreakdown;
                this.dataService.enableMandatoryVin = appsettings.enableMandatoryVin;
                this.dataService.globalSearchIncludeArchivedOrders = appsettings.globalSearchIncludeArchivedOrders;
                this.dataService.isMileageMandatory = appsettings.isMileageMandatory;
                this.dataService.isRegStateMandatory = appsettings.isRegStateMandatory;
                this.dataService.isLicensePlateMandatory = appsettings.isLicensePlateMandatory;
                this.dataService.isTrackMileageInAndOut = appsettings.isTrackMileageInAndOut && appsettings.isMileageInAndOutEnabled && appsettings.isMileageMandatory;
                this.dataService.isTaxRateBreakdown = appsettings.isTaxRateBreakdown;
                this.dataService.isVinMandatory = appsettings.isVinMandatory;
                this.dataService.isEnhancedGlobalSearchEnabled = appsettings.isEnhancedGlobalSearchEnabled;
                this.dataService.partsTechEnabled = appsettings.partsTechEnabled;
                this.dataService.isTireStorageEnabled = appsettings.isTireStorageEnabled;
                this.dataService.isPartsOrderingDisassociateEnabled = appsettings.isPartsOrderingDisassociateEnabled;
                this.dataService.isGoogleOnlineBookingEnabled = appsettings.isGoogleOnlineBookingEnabled;
                this.dataService.isMitchellIntegrationEnabled = appsettings.isMitchellIntegrationEnabled;
                this.dataService.isMitchell1EstimatorEnabled = appsettings.isMitchell1EstimatorEnabled;
                this.dataService.isPartsOrdingCostEditabled = appsettings.isPartsOrdingCostEditabled;
                this.dataService.isPartsOrderingInvCheckEnabled = appsettings.isPartsOrderingInvCheckEnabled;
                this.dataService.isFeeAssociationEnabled = appsettings.isFeeAssociationEnabled;
                this.dataService.isDiscountItemEnabled = appsettings.isDiscountItemEnabled;
                this.dataService.isMarketingOptOutEnabled = appsettings.isMarketingOptOutEnabled;
                this.dataService.isShortIoEnabled = appsettings.isShortIoEnabled;
                this.dataService.isManualTechLogEnabled = appsettings.isManualTechLogEnabled;
                this.dataService.isTechManualTechLogEnabled = appsettings.isTechManualTechLogEnabled;
                this.dataService.isSQSEnabled = appsettings.isSQSEnabled;
                this.dataService.isOnlinePaymentEnable = appsettings.isOnlinePaymentEnable;
                this.dataService.itemMovmentReport = appsettings.itemMovmentReport;
                this.dataService.isEnhancedTSEnabled = appsettings.isTireStorageEnabled;
                this.dataService.isCoreCostManagementEnabled = appsettings.isCoreCostManagementEnabled;

                // In case of primary payment payrix or globalPay
                if (appsettings.primaryPaymentProvider === 'payrix') {
                  this.dataService.isPrimaryPaymentPayrix = true;
                } else if (appsettings.primaryPaymentProvider === 'globalPay') {
                  this.dataService.isPrimaryPaymentGlobalPay = true;
                }

                this.dataService.isPayrixConnected = appsettings.isPayrixConnected;
                this.dataService.profitabilityUseWorkedHours = appsettings.profitabilityUseWorkedHours;
                this.dataService.isStatementZipFileEnabled = appsettings.isStatementZipFileEnabled;
                this.dataService.marketingSettings = appsettings.marketingSettings;
                this.dataService.isWorkAsTechEnabled = appsettings.isWorkAsTechEnabled;
                this.dataService.isFleetTaxOverRideEnabled = appsettings.isFleetTaxOverRideEnabled;
                this.dataService.isInvCodEqToEstCode = appsettings.isInvCodEqToEstCode;
                this.dataService.isTechSelfAssignUnassignService = appsettings.isTechSelfAssignUnassignService;
                this.dataService.isGreyScaleThemeEnabled = appsettings.isGreyScaleThemeEnabled;
                this.dataService.isMultiLocationEnabled = appsettings.isMultiLocationEnabled;
                this.dataService.isAudibleNotificationsEnabled = appsettings.isAudibleNotificationsEnabled;
                this.dataService.isRoLevelFeeEnabled = appsettings.isRoLevelFeeEnabled;
                this.dataService.isFeeReportingEnabled = appsettings.isFeeReportingEnabled;
                this.dataService.isApptRequestPortalEnabled = appsettings.isApptRequestPortalEnabled;
                this.dataService.isTireHubEnabled = appsettings.isTireHubEnabled;
                this.dataService.isTireConnectEnabled = appsettings.isTireConnectEnabled;
                this.dataService.isUnfillInspChecklistVisible = appsettings.isUnfillInspChecklistVisible;
                this.dataService.displayExternalServiceNotes = appsettings.displayExternalServiceNotes;
                this.dataService.isFluidSpecsEnabled = appsettings.isFluidSpecsEnabled;
                this.dataService.isFluidPartLookupTypeEnabled = appsettings.isFluidPartLookupTypeEnabled;
                this.dataService.autoQboPostingFromPayLinkPayment = appsettings.autoQboPostingFromPayLinkPayment;
                this.dataService.paymentSignatureOnlinePayment = appsettings.paymentSignatureOnlinePayment;
                this.dataService.isFloridaStateComplianceUpdates = appsettings.isFloridaStateComplianceUpdates;
                this.dataService.isTaxDetailsBreakDown = appsettings.isTaxDetailsBreakDown;
                this.dataService.isFloridaStateComplianceUpdates = appsettings.isFloridaStateComplianceUpdate;
                this.dataService.isCashDrawerReconciliation = appsettings.isCashDrawerReconciliation;
                this.dataService.isCashDrawerPending = appsettings.isCashDrawerPending;
                this.dataService.isOpenInSameTabEnabled = appsettings.isOpenInSameTabEnabled;
                this.dataService.isFlatRateEnabled = appsettings.isFlatRateEnabled;
                this.dataService.isGlobalCategoryEnabled = appsettings.isGlobalCategoryEnabled;
                this.dataService.isRoyaltyReportEnabled = appsettings.isRoyaltyReportEnabled;
                this.dataService.accountPayablePayment = appsettings.accountPayablePayment;
                this.dataService.isManualPartOrderingEnabled = appsettings.isManualPartOrderingEnabled;
                this.dataService.isCustomPoNumberEnabled = appsettings.isCustomPoNumberEnabled;
                this.dataService.isLockOrderEnabled = appsettings.isLockOrderEnabled;
                this.dataService.isItemCoreVisibleOnKanban = appsettings.isItemCoreVisibleOnKanban;
                this.dataService.isCommissionPlanEnabled = appsettings.isCommissionPlanEnabled;
                this.dataService.isCommissionLabor = appsettings.isCommissionLabor;
                this.dataService.isCommissionParts = appsettings.isCommissionParts;
                this.dataService.isCommissionTire = appsettings.isCommissionTire;
                this.dataService.isCommissionTireStorage = appsettings.isCommissionTireStorage;
                this.dataService.isCommissionFees = appsettings.isCommissionFees;
                this.dataService.isCoreFilterEnabled = appsettings.isCoreFilterEnabled;
                this.dataService.isAdHocCommissionable = appsettings.isAdHocCommissionable;
                this.dataService.isShowPaymentInPdf = appsettings.isShowPaymentInPdf;
                this.dataService.isEstimateDepositEnabled = appsettings.isEstimateDepositEnabled;
                this.dataService.isAutomatedFollowUpEnabled = appsettings.isAutomatedFollowUpEnabled;
                this.dataService.isAutomatedFollowUpOnByCustomer = appsettings.isAutomatedFollowUpOnByCustomer;
                this.dataService.updateItemSupplierBasedOnRecentPo = appsettings.updateItemSupplierBasedOnRecentPo;
                this.dataService.updateItemCostCannedAndFlatRatePO = appsettings.updateItemCostCannedAndFlatRatePO;
                this.dataService.isTechnicianSummaryByAllServicesEnabled = appsettings.isTechnicianSummaryAllServices;
                this.dataService.isCAStateComplianceEnabled = appsettings.isCAStateComplianceEnabled;
                this.dataService.isDisplayAuthorizationLogs = appsettings.isDisplayAuthorizationLogs;
                this.dataService.isUserCenterEnabled = appsettings.isUserCenterEnabled;
                this.dataService.isSplitTechActuallBillableHrs = appsettings.isSplitTechActuallBillableHrs;
                this.dataService.isJournalEntryEnabled = appsettings.isJournalEntryEnabled;
                this.dataService.isShowLineItemDisInPdf = appsettings.isShowLineItemDisInPdf;
                this.dataService.isBusinessSummaryReportEnabled = appsettings.isBusinessSummaryEnabled;
                this.dataService.isCalculateChangeEnabled = appsettings.isCalculateChangeEnabled;
                this.dataService.isInvoiceLockEnabled = appsettings.isInvoiceLockEnabled;
                this.dataService.isInvoiceLockOn = appsettings.isInvoiceLockOn;
                this.dataService.isSupplierReportEnabled = appsettings.isSupplierReportEnabled;
                this.dataService.isTransferVehicleEnabled = appsettings.isTransferVehicleEnabled;
                this.dataService.isGlobalPayEnabled = appsettings.isGlobalPayEnabled;
                this.dataService.isOverrideCostWithTechRate = appsettings.isOverrideCostWithTechRate;
                this.dataService.isMarkAsInventoryEnabled = appsettings.isMarkAsInventoryEnabled;
                this.dataService.isSandboxIntegrationEnabled = appsettings.isSandboxIntegrationEnabled;
                this.dataService.isUnifiedPartsOrderingDialogEnabled = appsettings.isUnifiedPartsOrderingDialogEnabled;
                this.dataService.isDisplayPaymentBannerEnabled = appsettings.isDisplayPaymentBannerEnabled;
                this.dataService.isAdminTechControlEnabled = appsettings.isAdminTechControlEnabled;
                this.dataService.customerEmailRequired = appsettings.customerMandatoryFields?.email;
                this.dataService.customerPhoneRequired = appsettings.customerMandatoryFields?.mobile;
                this.dataService.customerMandatoryFields = appsettings.customerMandatoryFields;
                this.dataService.isRegStateMandatory = appsettings.isRegStateMandatory;
                this.dataService.isLicensePlateMandatory = appsettings.isLicensePlateMandatory;
                this.dataService.isRepairLinkEnabled = appsettings.isRepairLinkEnabled;
                this.dataService.isOnlineInvOrderEnabled = appsettings.isOnlineInvOrderEnabled;
                this.dataService.isDVICannedNotesEnabled = appsettings.isDVICannedNotesEnabled;
                this.dataService.addMediaToInspections = appsettings.addMediaToInspections;
                this.dataService.isQuickTireLookupEnabled = appsettings.isQuickTireLookupEnabled;
                this.dataService.isInvCodeVisibleOnKanban = appsettings.isInvCodeVisibleOnKanban;
                this.dataService.isMarkPsDashboard = appsettings.isMarkPsDashboard;
                this.dataService.isInventoryReturnEnabled = appsettings.isInventoryReturnEnabled;
                this.dataService.isCustomerPaymentEnabled = appsettings.isROAEnabled;
                this.dataService.isPermanentRODeleteEnabled = appsettings.isPermanentRODeleteEnabled;
                this.dataService.isAdjustmentInvoicesEnabled = appsettings.isAdjustmentInvoicesEnabled;
                this.dataService.isAccountingExportsEnabled = appsettings.isAccountingExportsEnabled;
                this.dataService.isMarkPartsDeliveredIndividuallyEnabled = appsettings?.isMarkPartsDeliveredIndividuallyEnabled || appsettings?.isSplitDeliveriesEnabled;
                this.dataService.isPreferredLocationsEnabled = appsettings.isPreferredLocationsEnabled;
                this.dataService.isAutoServiceAuthorizationEnabled = appsettings.isAutoServiceAuthorizationEnabled;
                this.dataService.isAutoAuthorizeService = appsettings.isAutoAuthorizeService;
                this.dataService.isGainSightPXEnabled = appsettings.isGainSightPXEnabled;
                this.dataService.isCustomerConcernEnabled = appsettings.isCustomerConcernEnabled;
                this.dataService.isAttributeBasedPricingEnable = appsettings.isAttributeBasedPricingEnable;
                this.dataService.isNewItemCategoriesEnable = appsettings.isNewItemCategoriesEnable;
                this.dataService.preferredInventoryOnlineLookup = appsettings.preferredInventoryOnlineLookup;
                this.dataService.isSalesCodeEnabled = appsettings.isSalesCodeEnabled;
                this.dataService.isTireStorage2Enabled = appsettings.isTireStorage2Enabled;
                this.isTireStorage2Enabled = appsettings.isTireStorage2Enabled;
                this.dataService.isDvi2Enabled = appsettings.isDvi2Enabled;
                this.dataService.isMarketingEmailEnabled = appsettings.isMarketingEmailEnabled;
                this.dataService.isEnhancedEstimateAndInvoiceEnabled = appsettings.isEnhancedEstimateAndInvoiceEnabled;
                this.dataService.isCreateCustomInspections = appsettings.isCreateCustomInspections;
                this.dataService.isRevenueRecognitionSettleEnabled = appsettings.isRevenueRecognitionSettleEnabled;
                this.dataService.isChargeAccountEnabled = appsettings.isChargeAccountEnabled;
                this.dataService.isCustomerVehicleMandatoryFieldsEnabled = appsettings.isCustomerVehicleMandatoryFieldsEnabled;
                this.dataService.isCustomReportingEnabled = appsettings.isCustomReportingEnabled;
                this.dataService.isOrderRangeFilterEnabled = appsettings.isOrderRangeFilterEnabled;
                this.dataService.isNewBusinessSummary = appsettings.isNewBusinessSummary;
                this.dataService.isPOFieldsReqForDeliveryEnabled = appsettings.isPOFieldsReqForDeliveryEnabled;
                this.dataService.isSplitDeliveriesEnabled = appsettings.isSplitDeliveriesEnabled;
                this.dataService.tireConnectInventoryPOsEnabled = appsettings.tireConnectInventoryPOsEnabled;
                this.dataService.isEditedPoAndOnlineOrderCostCoreEnabled = appsettings.isEditedPoAndOnlineOrderCostCoreEnabled;
                this.dataService.isCommissionVisibleForTechsServiceWriters = appsettings.isCommissionVisibleForTechsServiceWriters;
                this.dataService.isDotNumberReqOnInv = appsettings.isDotNumberReqOnInv;
                this.dataService.isSubletTrackingEnabled = appsettings.isSubletTrackingEnabled;
                this.dataService.chargeAccounts = appsettings.chargeAccounts;
                this.dataService.isPassThroughTaxEnable = appsettings.isPassThroughTaxEnable;
                this.dataService.isWriteOffEnable = appsettings.isWriteOffEnable;
                this.dataService.isPricingManagementEnable = appsettings.isPricingManagementEnable;
                this.dataService.isPaymentDataPrivilgesEnabled = appsettings.isPaymentDataPrivilgesEnabled;
                this.dataService.speedDialEnabled = appsettings.speedDialEnabled;
                this.dataService.isPartWarrantiesEnabled = appsettings.isPartWarrantiesEnabled;
                this.dataService.isTireWarrantyPolicyEnabled = appsettings.isTireWarrantyPolicyEnabled;
                this.dataService.isQuickServiceEnabled = appsettings.isQuickServiceEnabled;
                this.dataService.isPartialOrderingEnabled = appsettings.isPartialOrderingEnabled;
                this.dataService.poFieldRequiredOn = appsettings.poFieldRequiredOn === 'finalize' ? true : false;
                this.dataService.nonInventoryPosItems = appsettings.nonInventoryPosItems;
                this.dataService.isUseOnlinePricing = appsettings.isUseOnlinePricing;
                this.dataService.isCountTaxExemptROAsNonTaxedEnable = appsettings.isCountTaxExemptROAsNonTaxedEnable;
                this.dataService.isQTQAddOnEnable = appsettings.isQTQAddOnEnable;
                this.dataService.isMotorGen2Enabled = appsettings.isMotorGen2Enabled;
                this.dataService.isOilStickerImproved = appsettings.isOilStickerImproved;
                this.dataService.excludeCoreCostInPOs = appsettings.excludeCoreCostInPOs;
                this.dataService.isStockTransferEnabled = appsettings.isStockTransferEnabled;
                this.dataService.isUpdatedCatalogPricingEnabled = appsettings.isUpdatedCatalogPricingEnabled;
                this.dataService.isRoyaltyReportEnabled = appsettings.isRoyaltyReportsEnable;
                this.dataService.isMidasRoyaltyReportsEnable = appsettings.isMidasRoyaltyReportsEnable;
                this.dataService.isInventoryManagementEnabled = appsettings.isInventoryManagementEnabled;
                this.dataService.isNewPartModalEnabled = appsettings.isNewPartModalEnabled;
                this.dataService.isNewTireModalEnabled = appsettings.isNewTireModalEnabled;
                this.dataService.isWarrantyNumberAddonEnabled = appsettings.isWarrantyNumberAddonEnabled;
                this.dataService.isFeeAndDiscountOnPOEnabled = appsettings.isFeeAndDiscountOnPOEnabled;
                this.dataService.isMyFleetCenterConnected = appsettings.isMyFleetCenterConnected;
                this.dataService.isSMSCampaignLimitEnabled = appsettings.isSMSCampaignLimitEnabled;
                this.dataService.isGoogleAddressSearchEnabled = appsettings.isGoogleAddressSearchEnabled;
                this.dataService.isMotorEnabled = appsettings.motorEnabled;
                this.dataService.isMotorLookupEnabled = appsettings.motorEnabled && appsettings.isMotorLookupEnabled;
                this.dataService.isMyFleetCenterEnabled = appsettings.isMyFleetCenterEnabled;
                this.dataService.isNewMarketGroupFilterEnabled = true; //  appsettings.isNewMarketGroupFilterEnabled;
                this.isMotorLookupEnabled = this.dataService.isMotorLookupEnabled;
                this.marketingAccessType = appsettings.marketingSettings.accessType;
                this.isQuickTireLookupEnabled = appsettings.isQuickTireLookupEnabled;
                this.dataService.isCreditSMSEnabled = appsettings.isCreditSMSEnabled;

                this.httpService.getCompanyPreferredLanguage().then((res: any) => {
                  this.dataService.setCompanyLocalization(res.localization);
                });

                if (user.currentShopId?.appsettings) {
                  const shopSetting = user.currentShopId?.appsettings;
                  this.dataService.manualOrderTaxationSetting = {
                    part: shopSetting.manualOrderSettings?.isTaxablePart,
                    tire: shopSetting.manualOrderSettings?.isTaxableTire,
                  };
                }

                if (user?.currentShopId?.address?.country) {
                  this.dataService.locationAddress = user.currentShopId.address;
                }

                if (user.currentShopId?.appsettings) {
                  const shopSetting = user.currentShopId?.appsettings;

                  this.dataService.isRoyaltyReportEnabled = shopSetting?.isRoyaltyReportsEnable;
                  this.dataService.isQuickServiceEnabled = shopSetting?.isQuickServiceEnabled;
                  this.dataService.isMotorGen2Enabled = shopSetting?.isMotorGen2Enabled;
                  this.dataService.isMileageMandatory = shopSetting?.isMileageMandatory;
                  this.dataService.enableMandatoryVin = shopSetting?.enableMandatoryVin;
                  this.dataService.globalSearchIncludeArchivedOrders = shopSetting?.globalSearchIncludeArchivedOrders;
                  this.dataService.isTrackMileageInAndOut = shopSetting?.isTrackMileageInAndOut && shopSetting?.isMileageInAndOutEnabled && shopSetting?.isMileageMandatory;
                  this.dataService.excludeCoreCostInPOs = shopSetting?.excludeCoreCostInPOs;
                  this.dataService.isEditedPoAndOnlineOrderCostCoreEnabled = shopSetting?.isEditedPoAndOnlineOrderCostCoreEnabled;
                  this.dataService.nonInventoryPosItems = shopSetting?.nonInventoryPosItems;
                  this.dataService.isCalculateChangeEnabled = shopSetting?.isCalculateChangeEnabled;
                  this.dataService.isInvCodeVisibleOnKanban = shopSetting?.isInvCodeVisibleOnKanban;
                  this.dataService.isItemCoreVisibleOnKanban = shopSetting?.isItemCoreVisibleOnKanban;
                  this.dataService.isGlobalPayEnabled = shopSetting?.isGlobalPayEnabled;
                  this.dataService.isOnlinePaymentEnable = shopSetting?.isOnlinePaymentEnable;
                  this.dataService.isPayrixConnected = shopSetting?.isPayrixConnected;
                  this.dataService.paymentSignatureOnlinePayment = shopSetting?.paymentSignatureOnlinePayment;
                  this.dataService.autoQboPostingFromPayLinkPayment = shopSetting?.autoQboPostingFromPayLinkPayment;
                  this.dataService.isROPrioritiesEnabled = shopSetting?.isROPrioritiesEnabled;
                  this.dataService.customerEmailRequired = shopSetting.customerMandatoryFields?.email;
                  this.dataService.customerPhoneRequired = shopSetting.customerMandatoryFields?.mobile;
                  this.dataService.customerMandatoryFields = shopSetting.customerMandatoryFields;
                  this.dataService.isAutoAuthorizeService = shopSetting.isAutoAuthorizeService;
                  this.dataService.isPreferredLocationsEnabled = shopSetting.isPreferredLocationsEnabled;
                  this.dataService.isInvoiceLockOn = shopSetting.isInvoiceLockOn;
                  this.dataService.isInvoiceLockEnabled = shopSetting.isInvoiceLockEnabled;
                  this.dataService.isMyFleetCenterConnected = shopSetting.isMyFleetCenterConnected;
                  this.dataService.isDotNumberReqOnInv = shopSetting.isDotNumberReqOnInv;
                  this.dataService.isChargeAccountEnabled = shopSetting.isChargeAccountEnabled;
                  this.dataService.isPassThroughTaxEnable = shopSetting.isPassThroughTaxEnable;
                  this.dataService.speedDialEnabled = shopSetting.speedDialEnabled;
                  this.dataService.poFieldRequiredOn = shopSetting.poFieldRequiredOn === 'finalize' ? true : false;
                  this.dataService.chargeAccounts = shopSetting.chargeAccounts;
                  this.dataService.isRegStateMandatory = shopSetting.isRegStateMandatory;
                  this.dataService.isLicensePlateMandatory = shopSetting.isLicensePlateMandatory;
                  this.dataService.isEnhancedEstimateAndInvoiceEnabled = shopSetting.isEnhancedEstimateAndInvoiceEnabled;

                  // need to reset don't need cmopnay level setting;
                  this.dataService.isPrimaryPaymentPayrix = false;
                  this.dataService.isPrimaryPaymentGlobalPay = false;

                  // in case of primary payment payrix or globalPay
                  if (shopSetting.primaryPaymentProvider === 'payrix') {
                    this.dataService.isPrimaryPaymentPayrix = true;
                  } else if (shopSetting.primaryPaymentProvider === 'globalPay') {
                    this.dataService.isPrimaryPaymentGlobalPay = true;
                  }
                }

                if (!this.dataService.isCustomerVehicleMandatoryFieldsEnabled && this.dataService.customerMandatoryFields) {
                  this.dataService.customerMandatoryFields.address = false;
                  this.dataService.isRegStateMandatory = false;
                  this.dataService.isLicensePlateMandatory = false;
                }

                // override settings
                if (Object.keys(settings).length > 0) {
                  this.dataService.isGlobalPayConnected = !!settings?.isGlobalPayConnected;
                  this.dataService.isGlobalPaySwipeConnected = !!settings?.isGlobalPaySwipeConnected;
                }
                if (appsettings?.isMultiLocationEnabled && this.dataService.isPreferredLocationsEnabled) {
                  this.dataService.sendData(this.dataService.typePassData('company-appdata-updated', {}));
                }
                if (this.dataService.isCashDrawerReconciliation && this.dataService.isCashDrawerPending) {
                  //  block everything and populate
                  this.isNavigationDisabled = true;
                  this.openCashRecancilationCheck();
                }

                if (this.dataService.isMitchellIntegrationEnabled) {
                  this.getMitchellConnection();
                }

                if (appsettings.mileageMeasuringUnit) {
                  this.dataService.defaultMileageUnit = appsettings.mileageMeasuringUnit;
                } else if (address) {
                  this.dataService.defaultMileageUnit = address.country === 'Canada' ? 'km' : 'mi';
                }

                if (appsettings.accPayableTerms) {
                  this.dataService.accPayableTerms = appsettings.accPayableTerms;
                }

                this.dataService.isCarfaxEnabled = true;
              }

              this.dataService.isCompanyLoading = false;

              this.setPlayerId();

              if (this.dataService.isGainSightPXEnabled) {
                this.setGainSightSettings(company);
              }

              this.setPendoSettings();

              this.setPrivileges();
              this.dataService.updateTxt();
              this.dataService.sendData(this.dataService.typePassData('company-appdata-updated', {}));
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.dataService.isCompanyLoading = false;
          this.fetchingData = true;
        });
    }
  }

  setPlayerId() {
    setTimeout(async () => {
      const { OneSignal } = window as any;

      if (OneSignal?.getUserId) {
        const playerId = await OneSignal.getUserId();

        await this.httpService.setNotificationPlayerId(playerId);
      }
    }, 1000);
  }

  navigate(url: string, navId: string, name: string) {
    this.disableApt.emit();
    if (!this.allowedMenuItems[navId]) {
      this.openAccessRestrictedDialog(name);
      return;
    }
  }

  navigateToALDashboard(url: string, navId: string, name: string) {
    const { corporateId } = this.helperService.getCompany();
    // if (!this.isNavigationDisabled) {
    //   if (navId === 'dashboard' && !corporateId && this.dataService.isMarkPsDashboard) {
    //     let url = this.alDashboardUrl;
    //     if (this.dataService.currentShopId && this.dataService.partnerId && this.dataService.userEmail) {
    //       let locationId = this.dataService.currentShopId;
    //       locationId = locationId.substring(locationId.length - 8);
    //       url = `${this.alDashboardUrl}?email=${this.dataService.userEmail}&key=${this.dataService.partnerId}&locationId=${locationId}`
    //     }
    //     window.open(url, '_blank');
    //   }
    // }
  }

  closeLockscreen() {
    this.disableApt.emit();
  }

  setPrivileges() {
    const employee = this.helperService.deepCopy(this.dataService.currentEmployeeDetails);
    const { privileges } = employee;
    const { isSupportUser } = this.helperService.getCompany();

    this.privileges = privileges;
    this.aclService.buildACL(this.privileges);
    this.flattenPrivileges();

    const privilegeMap = {};

    if (this.privileges?.length) {
      this.privileges.forEach((privilege) => {
        privilegeMap[privilege.title] = privilege;
      });
    }
    const invCodeUdatePrivilege = 'invoice-number-update';
    const endSessionPrivilege = 'save-end-session';
    const commissionPlanPrivilege = 'commission-plan';
    const revertToEstimatePrivilege = 'revert-invoices';
    const restoreDeleteRO = 'restore-delete-ro';
    const adjustmentFinalization = 'finalize-adjustment-invoice';
    const arAccountManagement = 'ar-account-management';
    const pricingMatricesManagement = 'pricing-management';
    const changePaymentData = 'change-payment-date';
    const managePaymentTypesAndMethods = 'manage-payment-types-method';
    const updateInventoryPO = 'update-inventory-PO';
    const manageStockAdjustment = 'manage-stock-adjustment';
    const isAccountingExportsEnabled = 'accounting-exports';
    const isRoyaltyPermissionEnabled = 'royalty-privileges';
    const manageClassification = 'catalog-classficiation';
    const editCustVehMandatoryFields = 'customer-mandatory-field-edit';
    const manageSalesCodePermissions = 'create-update-salescode';

    this.dataService.isRoyaltyPermissionEnabled = privilegeMap[isRoyaltyPermissionEnabled]?.permitted;
    this.dataService.canUpdateInvoiceNumber = privilegeMap[invCodeUdatePrivilege]?.permitted || ['admin', 'owner'].includes(this.role);
    this.dataService.canEndRestrictedSession = privilegeMap[endSessionPrivilege]?.permitted;
    this.dataService.canViewEditCommission = privilegeMap[commissionPlanPrivilege]?.permitted;
    this.dataService.canRevertToEstimate = privilegeMap[revertToEstimatePrivilege]?.permitted;
    this.dataService.canRestoreDeleteRO = privilegeMap[restoreDeleteRO]?.permitted;
    this.dataService.canFinalizedAdjustmentInvoices = privilegeMap[adjustmentFinalization]?.permitted || isSupportUser;
    this.dataService.isServiceStickyHeader = employee?.isServiceStickyHeader || false;
    this.dataService.isArAccountManagement = privilegeMap[arAccountManagement]?.permitted;
    this.dataService.isPricingMatricesManagement = privilegeMap[pricingMatricesManagement]?.permitted;
    this.dataService.canEditClassifications = privilegeMap[manageClassification]?.permitted || isSupportUser;
    this.dataService.canEditSalesCode = privilegeMap[manageSalesCodePermissions]?.permitted || isSupportUser;
    this.dataService.changePaymentData = privilegeMap[changePaymentData]?.permitted;
    this.dataService.managePaymentTypesAndMethods = privilegeMap[managePaymentTypesAndMethods]?.permitted;
    this.dataService.canUpdateStockManually = privilegeMap[manageStockAdjustment]?.permitted || isSupportUser;
    this.dataService.isUpdateInventoryPO = privilegeMap[updateInventoryPO]?.permitted || isSupportUser;
    this.dataService.isPermittedAccountingExportsEnabled = privilegeMap[isAccountingExportsEnabled]?.permitted;
    this.dataService.canUpdateCustVehMandatoryFields = true;

    if (this.dataService.isCustomerVehicleMandatoryFieldsEnabled) {
      this.dataService.canUpdateCustVehMandatoryFields = privilegeMap[editCustVehMandatoryFields]?.permitted || isSupportUser;
      // if (new RegExp('^midas$').test(this.dataService.company.enterprise)) this.dataService.canUpdateCustVehMandatoryFields = false;
      // else privilegeMap[editCustVehMandatoryFields]?.permitted || isSupportUser;
    }

    this.dataService.sendData(this.dataService.typePassData('user-privilege-updated', {}));
  }

  flattenPrivileges() {
    this.privileges.map((privilege) => {
      this.allowedMenuItems[privilege.title] = privilege.permitted;
    });
  }

  setClickOutSideListeners() {
    this.dataService
      .getClickEvent()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((target) => {
        if (this.profileDropdownContainer.nativeElement.contains(target)) {
        } else {
          if (this.isProfileCardVisible) {
            this.toggleProfileCard();
          }
        }
      });
  }

  toggleProfileCard() {
    this.isProfileCardVisible = !this.isProfileCardVisible;
  }

  closeSearch() {
    this.isSearchVisible = !this.isSearchVisible;
    this.showGlobalSearch = false;
  }

  openAccessRestrictedDialog(name: string) {
    const title = `${name} not enabled`;
    const subTitle = `It seems you don't have access to the ${name}. You can request access from your company admin.`;
    this.dialogService.open(AclDialogComponent, {
      width: '500px',
      styleClass: 'small-heading-dialog',
      data: { title, subTitle },
      showHeader: false,
    });
  }

  openConfirmCancelApptDialog(header: string, data?: any) {
    this.dialogService.open(CancelApptDialogComponent, {
      header: header,
      width: '500px',
      styleClass: 'small-heading-dialog',
      data: data,
      showHeader: false,
    });
  }

  openCannedServiceDialog(data?: any) {
    this.dialogService.open(CannedServiceDialogComponent, {
      width: '970px',
      styleClass: 'add-dialog canned-service-dialog',
      showHeader: false,
      data,
    });
  }

  // openflatRateItemDialog(data?: any) {
  //   this.dialogService.open(FlatRateAddComponent, {
  //     width: '1200px',
  //     height: '622px',
  //     styleClass: 'add-dialog flat-rate-dialog',
  //     showHeader: false,
  //     data,
  //   });
  // }

  openStatementDialog(data?: any) {
    this.dialogService.open(CreateStatementDialogComponent, {
      width: '1110px',
      styleClass: 'add-dialog add-statement-modal',
      showHeader: false,
      data,
    });
  }

  openPaymentDialog(data: any = {}, width = '670px') {
    const ref = this.dialogService.open(PaymentAddComponent, {
      width: width,
      styleClass: this.dataService.isRevenueRecognitionSettleEnabled
        ? 'add-dialog add-payment-modal edit-payment-fixed-width finalized-dialog'
        : 'add-dialog add-payment-modal edit-payment-fixed-width',
      showHeader: false,
      data: { ...data, isOpenFromTopNav: true },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close && close.isSuccess) {
        /*
        - If Order is paid full
        - If review in enable
        - If manualReviewRequest in enable
        - Then show Send Review dialog
        */
        const { result, reviewConfiguration } = close;
        if (result.isPaidFull && reviewConfiguration.review.googleReview.review && reviewConfiguration.review.googleReview.manualReviewRequest) {
          setTimeout(() => {
            this.openReviewDialog({
              estimateId: result.estimate._id,
              paymentId: result.payment._id,
            });
          }, 500);
        } else {
          setTimeout(() => {
            this.openPaymentReceiptModal({ data: result });
          }, 500);
        }

        if (result.estimate?.orderStatus !== 'invoice' && (result.isPaidFull || result.workFlowPaid)) {
          this.toaster = {
            text: `Order status for RO ${result.estimate?.code} was updated to Invoice.`,
            icon: 'fal fa-file-alt',
            buttons: {
              undo: 'Undo',
              sendInvoice: '',
            },
          };

          setTimeout(() => {
            this.showToaster = true;
          }, 2000);
        }
      }
      onClose.unsubscribe();
    });
  }

  openCreditPaymentDialog(data = {}, width = '670px') {
    const ref = this.dialogService.open(CreditPaymentAddComponent, {
      width: width,
      styleClass: 'add-dialog add-payment-modal fixedWidth',
      showHeader: false,
      data: data,
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      onClose.unsubscribe();
    });
  }

  openApplyCreditPaymentDialog(data = {}, width = '670px') {
    const ref = this.dialogService.open(ApplyCreditPaymentComponent, {
      width: width,
      styleClass: 'add-dialog add-payment-modal fixedWidth',
      showHeader: false,
      data: data,
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      onClose.unsubscribe();
    });
  }

  openPurchaseDialog(data = {}, width = '670px') {
    const ref = this.dialogService.open(PurchasePaymentOrder, {
      width: width,
      styleClass: 'add-dialog add-payment-modal fixedWidth',
      showHeader: false,
      data: data,
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close && close.isSuccess) {
        /*
        - If Order is paid full
        - If review in enable
        - If manualReviewRequest in enable
        - Then show Send Review dialog
        */
        this.openPaymentReceiptModal({ data: close.result });
      }
      onClose.unsubscribe();
    });
  }

  openServiceLookupDialog() {
    this.dialogService.open(ServiceLookupComponent, {
      // width: width,
      styleClass: 'add-dialog modal-stretched',
      showHeader: false,
    });
  }

  getIntegrationSettings(tireStoragePayload: any = null) {
    Promise.allSettled([this.getTireHubIntegrationSettings(), this.getTireConnectIntegrationSettings()])
      .then(
        (results: any) => {
          if (results && results?.length > 1) {
            if (results[0].value) {
              const { settings, isTireHubConnected, pricings = [], pricingRule = [] } = results[0].value;

              if (isTireHubConnected) {
                this.isTireHubConnected = true;
              }

              let locationRule: any = {};
              let companyRule: any = {};
              if (pricingRule?.length) {
                locationRule = find(pricingRule, { shopId: this.dataService.currentShopId, isCompanyLevelRule: false });
                companyRule = find(pricingRule, { isCompanyLevelRule: true });
              }
              let _pricingRule = this.getPricingRule(locationRule, companyRule);
              if (settings) {
                this.itemSettings.tireHub = {
                  tire: {
                    pricingRule: _pricingRule,
                    pricing: settings?.tirePricingId || {},
                    partsTechCostCalMethod: settings?.tireCostCalMethod || '',
                    shippingCostCalMethod: settings?.shippingCostCalMethod || '',
                    shippingPricing: settings?.shippingPricingId || '',
                  },
                };
              }
            }

            if (results[1].value) {
              const { settings, isTireConnectConnected, pricingRule = [] } = results[1].value;

              // Setting connection status and username and keys
              if (isTireConnectConnected) {
                this.isTireConnectConnected = true;
              }

              let locationRule: any = {};
              let companyRule: any = {};
              if (pricingRule?.length) {
                locationRule = find(pricingRule, { shopId: this.dataService.currentShopId, isCompanyLevelRule: false });
                companyRule = find(pricingRule, { isCompanyLevelRule: true });
              }

              let _pricingRule = this.getPricingRule(locationRule, companyRule);

              if (settings) {
                this.itemSettings.tireConnect = {
                  tire: {
                    pricingRule: _pricingRule,
                    pricing: settings?.tirePricingId || {},
                    partsTechCostCalMethod: settings?.tireCostCalMethod || '',
                    shippingCostCalMethod: settings?.shippingCostCalMethod || '',
                    shippingPricing: settings?.shippingPricingId || '',
                  },
                };
              }
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.openQuickTireLookupDialog(tireStoragePayload);
      });
  }

  getPricingRule(locationRule: any, companyRule: any) {
    if (locationRule && locationRule?.customOverRide?.length) {
      return locationRule.customOverRide = locationRule.customOverRide.map((overRide: any) => {
        return {
          ...overRide,
          pricingRuleId: locationRule._id,
        };
      });
    } else if (companyRule && companyRule.customOverRide?.length) {
      return companyRule.customOverRide = companyRule.customOverRide.map((overRide: any) => {
        return {
          ...overRide,
          pricingRuleId: companyRule._id,
        };
      });
    } else {
      return [];
    }
  }

  openQuickTireLookupDialog(tireStoragePayload: any = null) {
    let orderFromTab: string = 'ALinventory';
    if (this.isTireHubConnected) {
      orderFromTab = 'tireHub';
    } else if (this.isTireConnectConnected) {
      orderFromTab = 'tireConnect';
    }

    let payload: any = {
      selectedTab: 0,
      isTireConnectConnected: this.isTireConnectConnected,
      isTireHubConnected: this.isTireHubConnected,
      isOpenFromQuickTireLookup: true,
      isQuickTireLookupEnabled: this.isQuickTireLookupEnabled,
      tireConnectSettings: this.itemSettings.tireConnect,
      tireHubSettings: this.itemSettings.tireHub,
      orderFrom: orderFromTab,
    };

    if (this.isTireStorage2Enabled && tireStoragePayload && tireStoragePayload.isRunTireStorageFlow) {
      payload = {
        ...payload,
        ...tireStoragePayload,
      };
    }

    const ref = this.dialogService.open(VehicleSpecificLookupDialogComponent, {
      closeOnEscape: false,
      width: '1407px',
      styleClass: 'add-dialog vehicle-specific-modal',
      showHeader: false,
      data: payload,
      // data: {
      //   selectedTab: 0,
      //   isTireConnectConnected: this.isTireConnectConnected,
      //   isTireHubConnected: this.isTireHubConnected,
      //   isOpenFromQuickTireLookup: true,
      //   isQuickTireLookupEnabled: this.isQuickTireLookupEnabled,
      //   tireConnectSettings: this.itemSettings.tireConnect,
      //   tireHubSettings: this.itemSettings.tireHub,
      //   orderFrom: orderFromTab
      // },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      this.dataService.sendData(this.dataService.typePassData('qtq-modal-closed', {}));
      onClose.unsubscribe();
    });
  }

  openPaymentReceiptModal(data: any) {
    const ref = this.dialogService.open(PaymentReceiptComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data,
    });
  }

  openReviewDialog(data = {}) {
    const ref = this.dialogService.open(ReviewDialogComponent, {
      width: '1200px',
      styleClass: 'add-dialog modal-stretched',
      showHeader: false,
      data: data,
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      onClose.unsubscribe();
    });
  }

  openPartsTechParts({ type, payload }: any) {
    let prompt = { title: '', message: '' };

    // ALP-14118: Deferred popup comes up even after marking parts deferred
    if (payload?.services?.length === 1 && payload?.services[0]?.serviceStatus === 'deferred') {
      this.dataService.sendData(
        this.dataService.typePassData('unassign-partstech-parts-result', {
          type,
          payload,
          isSuccess: true,
        }),
      );
      return;
    }

    if (payload.isPartsTechOrderPlaced) {
      prompt = unAssignedPartsTechPartsMessage.submitted.noAssociated;
    } else {
      if (payload.partstechStatus === 'noAssociated') {
        this.dataService.sendData(
          this.dataService.typePassData('unassign-partstech-parts-result', {
            type,
            payload,
            isSuccess: true,
          }),
        );
        return;
      }
      prompt = unAssignedPartsTechPartsMessage.unSubmitted[payload.partstechStatus] || {};
    }

    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: prompt.title,
        message: prompt.message,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      this.dataService.sendData(
        this.dataService.typePassData('unassign-partstech-parts-result', {
          type,
          payload,
          isSuccess,
        }),
      );

      onClose.unsubscribe();
    });
  }

  openTrialPromotionalDialog(data = {}) {
    const ref = this.dialogService.open(TrialCampaignDialogComponent, {
      width: '45%',
      styleClass: 'add-dialog add-dialog-combine add-appt-modal trial-dialog',
      showHeader: false,
      data: data,
    });
  }

  openServiceAuthorizationDialog({ type, openFrom, payload, dialogType }) {
    const ref = this.dialogService.open(ServiceAuthorisationDialogComponent, {
      width: '1200px',
      styleClass: 'add-dialog lg-modal',
      showHeader: false,
      data: {
        data: {
          openFrom,
          estimateId: payload.orderId,
          serviceData: payload.serviceData,
          payload,
          isAutoAuthorizeService: this.dataService.isAutoAuthorizeService && this.dataService.isAutoServiceAuthorizationEnabled,
          dialogType,
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, order }) => {
      if (isSuccess) {
        this.dataService.sendData(
          this.dataService.typePassData('pending-auth-services-result', {
            type,
            payload,
            openFrom,
            isSuccess,
            order,
          }),
        );
      } else {
        this.dataService.sendData(this.dataService.typePassData('revert-pending-auth-services-action', {}));
      }

      onClose.unsubscribe();
    });
  }

  openAddDialog(tab: string, from: string, data: any, width = '45%') {
    if (this.isAddDialogModalOpen) {
      let message = 'Save the already opened appointment to create a new one';

      if (tab === 'add-vehicle') {
        message = 'Save the opened appointment to create vehicle for the customer';
      } else if (data && data._id) {
        message = 'Save the already opened appointment to open a new one';
      }

      this.helperService.showToaster('error', message);
      return;
    }

    this.isAddDialogModalOpen = true;
    const ref = this.dialogService.open(AddDialogComponent, {
      width: width,
      styleClass: 'add-dialog add-dialog-combine add-appt-modal',
      showHeader: false,
      data: {
        tab: tab,
        from: from,
        data: data,
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      this.isAddDialogModalOpen = false;
      onClose.unsubscribe();
      /** @todo dialog-workaround */
      setTimeout(() => {
        if (close && close.openFrom && close.openFrom === 'add-customer' && close.tab === 'add-customer') {
          if (close.from === 'estimate') {
            /**
             * This data is subscribe in estimate.component
             */
            this.dataService.sendData(
              this.dataService.typePassData('customer-for-estimate', {
                _id: close._id,
                fullName: close.fullName,
                email: close.email,
                phone: close.phone,
                customer: close.customer,
              }),
            );
            if (close.customer && close.customer.followUps && close.customer.followUps.length) {
              this.dataService.sendData(
                this.dataService.typeFollowUp('RO', {
                  event: 'customer_created',
                  customer: close.customer,
                  followUps: close.customer.followUps,
                  customerId: close.customer._id,
                }),
              );
            }
          } else {
            this.showAddedSuccessfully('', close);
          }

          /**
           * This data is subscribe in customer-list.component
           */
          this.dataService.sendData(this.dataService.typeUpdate('customer-list', 'customer'));
        } else if (close && close.openFrom && close.openFrom === 'add-vehicle' && close.tab === 'add-vehicle') {
          if (close.from === 'estimate') {
            /**
             * This data is subscribe in estimate.component
             */
            this.dataService.sendData(
              this.dataService.typePassData('vehicle-for-estimate', {
                vehicle: {
                  vehicleId: close.vehicle._id,
                  name: close.vehicle.name,
                  vehicle: close.vehicle.vehicle || {},
                },
              }),
            );
          } else {
            // this is to add new added vehicle in the list for customer center
            this.dataService.sendData(
              this.dataService.typePassData('vehicle-list-customer-center', {
                vehicle: {
                  vehicleId: close.vehicle._id,
                  name: close.vehicle.name,
                  vehicle: close.vehicle.vehicle || {},
                },
              }),
            );
            if (close.updateVehicleFlag) {
              this.helperService.showToaster('success', messages.vehicleInfoUpdate);
            } else {
              this.helperService.showToaster('success', messages.vehicleCreation);
            }
          }
        } else if (close && close.openFrom && close.openFrom === 'add-appointment' && close.tab === 'add-appointment') {
          if (close.type === 'create' && close.navigateToEstimate === false) {
            this.helperService.showToaster('success', messages.appointmentCreation);
          }
          /**
           * This data is subscribe in calendar-view.component
           */
          this.dataService.sendData(this.dataService.typeUpdate('calendar-view', 'calendar', close && close.data));
          /**
           * This data is subscribe in estimate.component
           */
          this.dataService.sendData(this.dataService.typeUpdate('estimate', 'estimate'));
        }
      }, 500);
    });
  }

  /** Open estimate view in new tab */
  openEstimate() {
    localStorage.setItem('roCreationSource', 'Top Navigation bar');
    this.helperService.openPageInNewExistingTab('/estimate', '_blank');
  }

  openHistoryImportDialog(data: any, type: string, isFromOrder: boolean = false) {
    this.dialogService.open(CustomerHistoryImportedDialogComponent, {
      width: '970px',
      styleClass: `add-dialog history-import-view-dialog ${type}`,
      showHeader: false,
      data: {
        type,
        isFromOrder,
        data,
      },
    });
  }

  openItemDialog(data: any, type: string, isFromOrder: boolean = false, vehicleYear?: any, isDisabled: boolean = false, estimate = {}, onlineItem = {}) {
    let styleModalClass = ``;
    if (type === 'part' && this.dataService.isNewPartModalEnabled) {
      styleModalClass = `add-dialog item-dialog new-part ${type}`;
    } else if (type === 'tire' && this.dataService.isNewTireModalEnabled) {
      styleModalClass = `add-dialog item-dialog new-tire ${type}`;
    } else if (type === 'tireStorage' && this.dataService.isEnhancedTSEnabled && !data.isTireStorage2Enabled && !this.dataService.isTireStorage2Enabled) {
      styleModalClass = `add-dialog item-dialog-tire-storage ${type}`;
    } else if (type === 'tireStorage' && (this.dataService.isTireStorage2Enabled || data.isTireStorage2Enabled)) {
      // tire-storage-detail-modal
      styleModalClass = `add-dialog item-dialog new-tire-storage`;
    } else {
      styleModalClass = `add-dialog item-dialog ${type}`;
    }

    this.dialogService.open(ItemDialogComponent, {
      width: '970px',
      styleClass: styleModalClass,
      showHeader: false,
      data: {
        estimate,
        type,
        isFromOrder,
        data,
        vehicleYear,
        isDisabled,
        onlineItem,
      },
    });
  }

  openFeeDialog(data: any, isOpenFromRO: boolean = false) {
    this.dialogService.open(FeeAddComponent, {
      width: '970px',
      styleClass: `add-dialog fee-dialog`,
      showHeader: false,
      data: { data, isOpenFromRO },
    });
  }

  openSupplierDialog(supplierId: any, isOpenFromRO: boolean = false) {
    this.dialogService.open(SupplierAddComponent, {
      width: '970px',
      styleClass: `add-dialog add-dialog-combine add-appt-modal`,
      showHeader: false,
      data: { supplierId, isOpenFromRO },
    });
  }

  openSubletSupplierDialog(supplierId: any, isSubletSupplierType: boolean, isOpenFromRO: boolean = false) {
    this.dialogService.open(SupplierAddComponent, {
      width: '970px',
      styleClass: `add-dialog add-dialog-combine add-appt-modal`,
      showHeader: false,
      data: { supplierId, isSubletSupplierType, isOpenFromRO },
    });
  }

  openLocationDialog(data: any, type: string, isFromOrder: boolean = false) {
    this.dialogService.open(LocationAddComponent, {
      styleClass: `add-dialog location-add-dialog ${type}`,
      showHeader: false,
      data: {
        type,
        isFromOrder,
        data,
      },
    });
  }

  _openItemDialog() {
    this.dataService.sendData(
      this.dataService.typePassData('open-item-dialog', {
        type: 'part',
        isOpenFromRO: false,
        data: {},
      }),
    );
  }
  /** Open add customer modal */
  showAddCustomer() {
    this.openAddDialog('add-customer', 'header-component', null);
  }

  showAddedSuccessfully(header: any, data?: any) {
    const ref = this.dialogService.open(AddSuccessfullyDialogComponent, {
      header: '',
      width: '420px',
      styleClass: 'small-heading-dialog customer-success-popup',
      data: data,
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close && close.data._id && close.data.fullName) {
        const estimate: any = {
          title: close.data.fullName,
          customer: {
            customerId: close.data._id,
            fullName: close.data.fullName,
            displayName: close.data.fullNameQBO,
            notes: close.data.notes,
            email: close.data.email,
            companyName: close.data.companyName,
            isFleetCustomer: close.data.isFleetCustomer,
            phone: close.data.phone,
            phone2: close.data.phone2,
          },
        };

        if (close.customerInfo?.vehicle?._id) {
          estimate.vehicle = close.customerInfo.vehicle;
          estimate.vehicle.name = estimate.vehicle.vehicleName ? estimate.vehicle.vehicleName : estimate.vehicle.name;
          estimate.vehicle.vehicleId = close.customerInfo.vehicle._id;
        }

        /** Create Estimate */
        this.httpService.createEstimates({ ...estimate, activity: [], browserSessionId: Date.now() }).then(
          (order: any) => {
            const queryParams: any = {
              browserSessionToken: order.restriction.token || '',
              checkPreferredLocation: order.checkPreferredLocation || false,
            };
            const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
            this.helperService.openPageInNewExistingTab(url, order._id);
            const roCreationSource = localStorage.getItem('roCreationSource');

            if (roCreationSource && this.dataService.isGainSightPXEnabled) {
              const estimateCreated: any = {
                roCreationSource,
                roNumber: order.code || '',
              };

              this.helperService.postGainsightPXEvent('RO Created', estimateCreated);
              localStorage.setItem('roCreationSource', '');
            }
          },
          (error) => {
            this.helperService.showToaster('error', error);
          },
        );
      }

      onClose.unsubscribe();
    });
  }

  /** Open add vehicle modal */
  showAddVehicle() {
    this.openAddDialog('add-vehicle', 'header-component', null);
  }

  /** Open add appointment modal */
  showAddAppointment() {
    this.openAddDialog('add-appointment', 'header-component', null);
  }

  /** Open add payment modal */
  showAddPayment() {
    this.openPaymentDialog({ isNewPayment: true });
  }

  /** handle click on add menu items */
  handleAddItemClick(type: string) {
    this.disableApt.emit();
    switch (type) {
      case 'customer':
        this.showAddCustomer();
        break;

      case 'appointment':
        this.showAddAppointment();
        break;

      case 'estimate':
        this.openEstimate();
        break;

      case 'vehicle':
        this.showAddVehicle();
        break;

      case 'part':
        this._openItemDialog();
        break;

      case 'payment':
        this.showAddPayment();
        break;
    }
  }

  onNotificaitonsClick() {
    const body = {
      ids: [],
    };
    this.customerNotifications.forEach((item) => {
      if (!item.isSeen) {
        body.ids.push(item._id);
      }
    });
    if (body.ids.length) {
      this.httpService.UpdateNotificationsStatus(body).then(
        (res) => {},
        (error) => {
          this.helperService.showToaster('error', error);
        },
      );
    }
  }

  onScrollingFinished(isMarkRead?) {
    if (!isMarkRead) {
      this.notificaitonsSkip += config.notificaitonsPageSize;
      this.notificationsLimit += config.notificaitonsPageSize;
      this.fetchNotifications();
    }
    if (this.notificationsTotalRecord > 0) {
      this.onNotificaitonsClick();
    }
  }

  fetchNotifications(isSocket?) {
    const conf = {
      limit: this.notificationsLimit,
      offset: 0,
      sortField: 'createdAt',
      search: '',
      sortOrder: '-1',
    };
    this.httpService.getNotifications(conf).then(
      (res) => {
        const hasAudibleNotifications = this.dataService.currentEmployeeDetails.hasAudibleNotifications;

        this.customerNotifications = res.records.length > 0 ? res.records : [];
        this.notificationsTotalRecord = res.unreadCount || 0;
        this.counts = { urgentCount: res.urgentCount, otherCount: res.otherCount };
        this.customerNotifications.forEach((notification) => {
          notification.text = this.helperService.parseCurrencyTags(notification.text);

          if (isSocket && this.dataService.isAudibleNotificationsEnabled) {
            const isAudibleNotifOn = notification.audibleNotification && hasAudibleNotifications;

            if (isAudibleNotifOn && this.notificationSettings?.enabled && notification.data && !notification.isSeen) {
              if (notification.data.notificationEventName === 'serviceFlagReopened') {
                notification.data.notificationEventName = 'serviceFlagRaised';
              }
              if (notification.data.notificationEmployeeId === this.employeeId) {
                this.sharedService.setNotificationSound(notification.data.notificationEventName, this.notificationSettings.officeApp);
              }
            }
          }
        });
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  getOpenChatCount(isSocket?, conversationClosed?) {
    this.chatService.getOpenChatCount().then(
      (res) => {
        this.openChatCount = res?.openChatCount;
        // this.notificationsTotalRecord = res?.unreadCount;
        localStorage.setItem('notificationsBadgeCount', JSON.stringify(this.notificationsTotalRecord));
        this.setChatSetting(isSocket, conversationClosed);
      },
      (error) => this.helperService.showToaster('error', error),
    );
  }

  setChatSetting(isSocket: Boolean = false, conversationClosed: Boolean = false) {
    const hasAudibleNotifications = this.dataService.currentEmployeeDetails.hasAudibleNotifications;
    if (isSocket && !conversationClosed && this.dataService.isAudibleNotificationsEnabled) {
      if (hasAudibleNotifications && this.notificationSettings?.enabled) {
        this.sharedService.setNotificationSound('customerMessageRecieved', this.notificationSettings.officeApp);
      }
    }
  }

  getEmployeeDetails(employeeId: string) {
    this.httpService
      .getEmployeeDetails(employeeId)
      .then((employee: any) => {
        this.dataService.currentEmployeeDetails = employee;
        //destruct privileges
        const { privileges } = employee;
        this.setPrivileges();
        // build ACL
        this.aclService.buildACL(privileges);
        this.dataService.sendData(this.dataService.typePassData('user-privilege-updated', {}));
      })
      .catch((error) => {
        console.error(error);

        if (error === 'Authentication failed.') {
          this.helperService.logout();
        }
      });
  }

  toggleHighlight() {
    this.selected = !this.selected;
  }

  toggleHighlightLocked() {
    this.selectedLocked = !this.selectedLocked;
  }

  navigateToChat() {
    const chatQueryParam = 'chat';
    this.helperService.openPageInNewExistingTab(`chat?message=${chatQueryParam}`, chatQueryParam);
  }

  openLocationSwitchDialog() {
    const ref = this.dialogService.open(SwitchLocationDialogComponent, {
      styleClass: 'add-dialog export-report-dialog',
      closeOnEscape: false,
      showHeader: false,
      data: { corporateId: this.corporateId },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.setUserDetails();
      }

      onClose.unsubscribe();
    });
  }

  openCorporateSwitchDialog() {
    const ref = this.dialogService.open(SwitchCorporateDialogComponent, {
      styleClass: 'add-dialog export-report-dialog',
      closeOnEscape: false,
      showHeader: false,
      data: {},
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
      }

      onClose.unsubscribe();
    });
  }

  openCashRecancilationCheck() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      closeOnEscape: false,
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        headerIcon: 'fas fa-exclamation-triangle font-icon-primary',
        headerIconPrimary: true,
        title: 'Please reconcile your cash drawer first',
        message: 'The time to reconcile the cash drawer has passed. Please reconcile the drawer to continue using the application',
        button: {
          success: { title: 'Go to Cash Drawer' },
        },
        isCloseButtonHidden: true,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.router.navigate(['reports/end-day-cash-drawer']);
      }

      onClose.unsubscribe();
    });
  }

  handleOpenMitchell1Guide(event: Event) {
    if (!this.isMitchell1Connected) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.isMitchell1Loading || !this.isMitchell1Connected) return;

    this.isMitchell1Loading = true;
    this.httpService
      .getMitchell1GuideLink({ searchTerm: '' })
      .then(
        (url) => {
          if (url) {
            window.open(url, '', `width=${window.outerWidth},height=${window.outerHeight}`);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isMitchell1Loading = false;
      });
  }

  getMitchellConnection() {
    if (this.isMitchell1CredsLoaded) return;

    this.httpService.isMitchell1Connected().then(
      (data: any) => {
        if (data) {
          this.isMitchell1Connected = data.isMitchell1Connected;
        } else {
          this.isMitchell1Connected = false;
        }
        this.isMitchell1CredsLoaded;
      },
      (err) => {},
    );
  }

  setWorldpacIntegration(force = false) {
    this.scriptLoaderService.loadScript('WorldpacScript').then(
      () => {
        const { WCAP } = this._window as any;
        this.dataService.speedDialScriptWindowObject = WCAP;

        if (force && WCAP) {
          this.dataService.sendData(
            this.dataService.typePassData('connected-speedDial', {
              wcap: WCAP,
            }),
          );
        }
        // let wcap = new WCAP.speedDIAL(WCAP.defaultPort, 'Name of SMS Vendor');
      },
      (err) => {
        console.log(err);
      },
    );
  }

}
